module.exports = __webpack_public_path__ + "static/img/expologo.f299452.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/autoshoplogo/expologo.jpg
// module id = B5j0
// module chunks = 0